import { useState, useEffect } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight,ChevronDown  } from "lucide-react"; 

function ImageSlider() {
	const [banner, setBanner] = useState([]);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [current, setCurrent] = useState(0);
	const [marq, setMarq] = useState([]);
	
	const handlePost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/banner", payload);
			
			
			// Loop data (array)
			setBanner(response.data || []);
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	
	
	const marqPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				department_id:'0',
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/marque", payload);
			
			
			// Loop data (array)
			setMarq(response.data || []);
		} catch (err) {
		   setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	useEffect(() => {
		handlePost();
		marqPost();
	}, []);
	
	
	useEffect(() => {
		if (banner.length === 0) return;
		const interval = setInterval(() => {
		  setCurrent((prev) => (prev + 1) % banner.length);
		}, 5000);
		return () => clearInterval(interval);
	}, [banner]);

	const nextSlide = () => {
		setCurrent((prev) => (prev + 1) % banner.length);
	};

	const prevSlide = () => {
		setCurrent((prev) => (prev - 1 + banner.length) % banner.length);
	};
	if (banner.length === 0) {
		return <div className="h-screen flex items-center justify-center">Loading...</div>;
	 }
	return (
	<>
		
		<div className="relative w-full h-[50vh] md:h-[80vh] overflow-hidden bg-green-100 z-0">
		  {banner.map((slide, index) => (
			<img
			  key={slide.id}
			  src={`${import.meta.env.VITE_API_SOURCE_URL}${slide.images_path}`}
			  alt={`Slide ${slide.id}`}
			  className={`absolute inset-0 w-full h-full
			  object-contain md:object-cover
			  transition-opacity duration-1000
			  ${index === current ? "opacity-100 animate-zoom" : "opacity-0"}`}
			  onError={(e) => (e.target.style.display = "none")}
			/>
		  ))}

		  {/* Prev Button */}
		  <button
			onClick={prevSlide}
			className="absolute left-2 md:left-4 top-1/2 -translate-y-1/2 bg-green-600 text-white p-2 md:p-4 rounded-full hover:bg-black/70 z-10"
		  >
			<ChevronLeft size={24} />
		  </button>

		  {/* Next Button */}
		  <button
			onClick={nextSlide}
			className="absolute right-2 md:right-4 top-1/2 -translate-y-1/2 bg-green-600 text-white p-2 md:p-4 rounded-full hover:bg-black/70 z-10"
		  >
			<ChevronRight size={24} />
		  </button>

		  {/* Dots */}
		  <div className="absolute bottom-4 md:bottom-8 left-1/2 -translate-x-1/2 flex gap-2 md:gap-3 z-10">
			{banner.map((_, index) => (
			  <button
				key={index}
				onClick={() => setCurrent(index)}
				className={`w-3 h-3 md:w-4 md:h-4 rounded-full ${
				  index === current ? "bg-white" : "bg-gray-400"
				}`}
			  />
			))}
		  </div>

		  {/* Scroll Down Indicator */}
		  <div className="absolute bottom-12 md:bottom-20 left-1/2 -translate-x-1/2 text-white animate-bounce z-10">
			<ChevronDown size={32} />
		  </div>
		</div>
		 <div className="bg-green-600 text-white py-3">
			<div className="container mx-auto flex items-center">
				{/* Label */}
				<span className="font-bold mr-4">Latest:</span>

				<div className="overflow-hidden whitespace-nowrap w-full">
				   <div className="animate-marquee inline-block" 
					style={{
					  display: "inline-block",
					  whiteSpace: "nowrap",
					  animation: "marquee 20s linear infinite",
					}}>
					{marq.map((item, index) => (
					  <Link
						key={item.id || index}
						to={marq.link}
						className="inline-flex items-center mr-10 hover:underline"
					  >
						<span className="bg-white text-green-600 text-xs px-2 py-0.5 rounded mr-2">
						  {new Date(item.date).toLocaleDateString()}
						</span>
						<span>{item.name}</span>
					  </Link>
					))}
				  </div>
				</div>
			</div>
		</div>
		<style>{`
        @keyframes marquee {
          0% { transform: translateX(100%); }
          100% { transform: translateX(-100%); }
        }
      `}</style>
	</>
  );
}

export default ImageSlider;
